// extracted by mini-css-extract-plugin
export default {"main_wrap":"PersonalInfoProvisionPage_main_wrap__jUKwe"};